"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stream = require("mithril/stream");
var m = require("mithril");
exports.focusedType = stream('fire');
exports.hoveredNode = stream(undefined);
function updateFocusedType(newType) {
    if (newType === exports.focusedType()) {
        return;
    }
    exports.focusedType(newType);
    m.redraw();
}
exports.updateFocusedType = updateFocusedType;
function updateHoveredNode(newNode) {
    if (newNode === exports.hoveredNode()) {
        return;
    }
    exports.hoveredNode(newNode);
    m.redraw();
}
exports.updateHoveredNode = updateHoveredNode;
function boundingDimensions(svg) {
    var boundingRect = svg.getBoundingClientRect();
    var width = boundingRect.width;
    var height = boundingRect.height;
    return { width: width, height: height };
}
exports.boundingDimensions = boundingDimensions;
function boundingWidth(svg) {
    return boundingDimensions(svg).width;
}
exports.boundingWidth = boundingWidth;
function visualisationTitle(hovered, focused) {
    if (hovered === undefined) {
        return '';
    }
    var attacking;
    var defending;
    if (hovered.direction === 'from') {
        attacking = hovered.name;
        defending = focused;
    }
    else {
        attacking = focused;
        defending = hovered.name;
    }
    return attacking + " gets " + hovered.multiplier + "x against " + defending;
}
exports.visualisationTitle = visualisationTitle;
//# sourceMappingURL=utils.js.map